import { useEffect, useMemo } from 'react';

export const BASE_PAGE_TITLE = 'ShieldCRM';

const sanitizeSegments = segments =>
  (segments || [])
    .map(segment => (typeof segment === 'string' ? segment.trim() : segment))
    .filter(segment => typeof segment === 'string' && segment.length > 0);

export const formatPageTitle = (segments, baseTitle = BASE_PAGE_TITLE) => {
  const cleanedSegments = sanitizeSegments(segments);
  if (!cleanedSegments.length) {
    return baseTitle;
  }
  return `${baseTitle} | ${cleanedSegments.join(' · ')}`;
};

const normalizeConfig = config =>
  typeof config === 'string' ? { page: config } : config || {};

export default function usePageTitle(configInput) {
  const { baseTitle = BASE_PAGE_TITLE, entity, section, page, suffix } =
    normalizeConfig(configInput);

  const resolvedTitle = useMemo(() => {
    return formatPageTitle([entity, section, page, suffix], baseTitle);
  }, [entity, section, page, suffix, baseTitle]);

  useEffect(() => {
    document.title = resolvedTitle;
  }, [resolvedTitle]);

  return resolvedTitle;
}
